import { useEffect } from 'react';
import { useTankCleaningStore } from '../context/TankCleaningContext';
import { ChemicalOrderStatus } from '../types/ViewModel/TankCleaning/Order/ChemicalOrderStatus';
import { createChemicalOrderPortCallList } from '../factory/TankCleaning/ChemicalOrderPortCallFactory';
import { ChemicalOrderPortCall } from '../types/ViewModel/TankCleaning/Order/ChemicalOrderPortCall';
import useApi from './useApi';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import useApiEndpoints from '../context/useApiEndpoints';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();

    const { setSelectedChemicalOrderForPortCallList } = useTankCleaningStore();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, postApiData } = useApi();

    useEffect(() => {
        if (state.status === 'success') {
            if (state.endpoint === apiEndpoints['createChemicalOrderStatus'].url) {
                const _chemicalOrderPortCallList: ChemicalOrderPortCall[] = createChemicalOrderPortCallList(state.result);
                if (_chemicalOrderPortCallList) {
                    setSelectedChemicalOrderForPortCallList([..._chemicalOrderPortCallList]);
                }
            }
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    const createChemicalOrderStatus = async (chemicalOrderStatus: ChemicalOrderStatus, imoNumber: number) =>
        await postApiData({
            endpoint: apiEndpoints['createChemicalOrderStatus'].url,
            data: chemicalOrderStatus,
            queryParam: buildQueryParams({ imoNumber: imoNumber }),
        });

    return {
        createChemicalOrderStatus,
    };
};
